<template>
  <div class="patent-detail">
    <!-- header -->
    <!-- <div class="patent-detail.block">
			<intellectual-header></intellectual-header>
		</div> -->
    <!-- 导航栏 -->
    <div class="patent-detail.block">
      <intellectual-navigation
        :isTrademark="isTrademark"
        @toggleTrademarks="toggleTrademarks"
      ></intellectual-navigation>
    </div>
    <div class="+navigation-line"></div>
    <!-- 面包屑 -->
    <div class="patent-detail.bread" data-aos="fade-left">
      <Bread
        :currentPage="{
          name: '专利信息',
          path: '/Patent',
          childName: '专利详情',
          childPath: $route.path,
        }"
      />
    </div>
    <div class="patent-detail.container">
      <!-- <common-detail :details="patentDetailFnl[0]"></common-detail> -->
      <section>
        <h4>{{ patentDetail.name }}</h4>
        <div class="sn">
          <p>专利号：</p>
          <span>{{ patentDetail.pub_card }}</span>
        </div>
        <!-- <div class="time" v-if="patentDetail.date_time"> -->
        <div class="time" v-show="patentDetail.date_time">
          <p>发布时间：</p>
          <span>{{ patentDetail.date_time }}</span>
        </div>
        <div class="infos">
          <img :src="patentDetail.image ? imgUrl + patentDetail.image : require('../assets/empty-big.png')" />
          <div class="info">
            <div
              class="infoChild"
              v-for="(item, index) in detail"
              :key="index"
              v-show="item.value"
            >
              <b :style="{ 'background-color': item.color }"></b>
              <p>{{ item.name }}</p>
              <span
                :style="{ color: item.color, 'border-color': item.color }"
                >{{ item.value }}</span
              >
            </div>
            <a
              download="说明书下载"
              :href="imgUrl + patentDetail.directions"
              target="_blank"
              >说明书下载</a
            >
          </div>
        </div>
      </section>
      <patent-intro :introduction="patentDetail.introduction"></patent-intro>
    </div>
    <!-- footer -->
    <common-footer></common-footer>
  </div>
</template>

<script>
import IntellectualHeader from "../components/intellectual-header.vue";
import IntellectualNavigation from "../components/intellectual-navigation.vue";
import CommonFooter from "../components/common-footer.vue";
import Bread from "../components/bread.vue";
import CommonDetail from "../components/common-detail.vue";
import PatentIntro from "../components/patent-intro.vue";

export default {
  components: {
    IntellectualHeader,
    IntellectualNavigation,
    CommonFooter,
    Bread,
    CommonDetail,
    PatentIntro,
  },
  data() {
    return {
      isTrademark: false,
      patentDetail: {},
      patentType: ["发明", "实用新型", "外观设计"],
      detail: [],
    };
  },
  // computed:{
  // patentDetailFnl(){
  // 	return this.patentDetail.map(({ name, image, introduction, id,type,date_time,card,applyer,price,research,directions}) => {
  // 	// return this.patentDetail.map(({ title, icon, desc, id,number,price,tel,research,Application,apOr,tradeType}) => {
  // 			return {
  // 				type:'专利',
  // 				name: name,
  // 				icon: image,
  // 				desc: introduction,
  // 				id: id ,
  // 				// date:date_time,
  // 				// tradeType:tradeType,
  // 				// Application:apOr,
  // 				// price:price,
  // 				// tel:tel,
  // 				// research:research,
  // 				// link:this.urlConfig.url +'/patent/pdf/' + id
  // 				// link:this.urlConfig.file.show + directions
  // 			}
  // 		})
  // }
  // },
  methods: {
    toggleTrademarks(val) {
      this.isTrademark = val;
    },
    initPatentDetail() {
      // this.patentDetail.push(JSON.parse(sessionStorage.getItem('detail')))
      this.http.get(`IPR_Patent/${this.$route.params.id}`).then((res) => {
        this.detail = [
          {
            color: "#6576FE",
            name: "IPC分类：",
            value: res.data.category_name,
          },
          {
            color: "#58A6FE",
            name: "专利权人：",
            value: res.data.applyer,
          },
          {
            color: "#6475FD",
            name: "公布日：",
            value: res.data.date_time,
          },
          {
            color: "#58A6FE",
            name: "电话：",
            value: "0931-8271700",
          },
        ];
        this.patentDetail = res.data;
      });
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.initPatentDetail();
  },
};
</script>

<style lang="scss">
@include component(patent-detail) {
  @include part(block) {
    min-width: $minWidth;
    padding: 0 25px;
    margin: 0 auto;
    width: 100%;
    background: #fff;
  }

  @include part(bread) {
    width: 100%;
    min-width: $minWidth;
    height: 51px;
    background: #fff;
  }

  @include part(container) {
    width: 100%;
    background: #f7f7f7;
    min-width: $minWidth;
    padding: 0 25px;
    margin: 0 auto;
    section {
      width: 1200px;
      margin: 0 auto;
      margin-top: 20px;
      background: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
      padding: 50px 50px 80px;
      h4 {
        font-size: 32px;
        font-weight: bold;
        color: #f47227;
        margin: 0;
        margin-bottom: 15px;
      }
      .sn {
        font-size: 28px;
        font-weight: 500;
        color: #000000;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .time {
        font-size: 22px;
        font-weight: 400;
        color: #000000;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 5px;
      }
      .infos {
        margin-top: 50px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        img {
          width: 550px;
          height: 330px;
          object-fit: contain;
          object-position: center;
          margin-right: 30px;
          border: 1px solid #eee;
          padding: 10px;
        }
        .info {
          width: calc(100% - 590px);
          height: 350px;
          display: flex;
          align-items: flex-start;
          justify-content: flex-start;
          flex-direction: column;
          .infoChild {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin-bottom: 26px;
            b {
              width: 18px;
              height: 18px;
              border-radius: 50%;
              margin-right: 20px;
              box-shadow: 0px 2px 6px 0px rgba(32, 52, 206, 0.3);
            }
            p {
              width: 120px;
              text-align: left;
              font-size: 20px;
              font-weight: 500;
              color: #272727;
            }
            span {
              padding: 10px 25px;
              font-size: 16px;
              font-weight: 500;
              border-style: solid;
              border-width: 2px;
              border-radius: 40px;
            }
            &:nth-of-type(2) {
              b {
                box-shadow: 0px 2px 6px 0px rgba(23, 103, 192, 0.3);
              }
            }
            &:nth-of-type(3) {
              b {
                box-shadow: 0px 2px 6px 0px rgba(211, 142, 31, 0.3);
              }
            }
            &:nth-of-type(4) {
              b {
                box-shadow: 0px 2px 6px 0px rgba(185, 66, 33, 0.3);
              }
            }
          }
          a {
            background: #f47227;
            font-size: 20px;
            font-weight: 500;
            color: #ffffff;
            padding: 15px 30px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
